module.exports = __webpack_public_path__ + "img/imgZXGH(31).c4aacdd8.png";